import React, { useState } from "react";
import { Phone, Mail, Menu, X } from "lucide-react";
import Logo from "../assets/images/Logo.png";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 text-white bg-[#00436b]" aria-label="Main Header">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="text-xl font-bold flex justify-center items-center">
            <img
              src={Logo}
              className="w-16 mr-2 md:w-20 md:m-4"
              alt="Elam Travels Trichy Logo"
            />
            Elam Travels Trichy
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 hover:bg-slate-800 rounded-lg transition"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            aria-label="Toggle Navigation Menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8">
            <a
              onClick={() => scrollToSection("home")}
              className="hover:text-orange-400 transition cursor-pointer"
              aria-label="Go to Home Section"
            >
              Home
            </a>
            <a
              onClick={() => scrollToSection("about")}
              className="hover:text-orange-400 transition cursor-pointer"
              aria-label="Go to About Us Section"
            >
              About Us
            </a>
            <a
              onClick={() => scrollToSection("vehicles")}
              className="hover:text-orange-400 transition cursor-pointer"
              aria-label="Go to Vehicle Types Section"
            >
              Vehicle Types
            </a>
            <a
              onClick={() => scrollToSection("services")}
              className="hover:text-orange-400 transition cursor-pointer"
              aria-label="Go to Services Section"
            >
              Services
            </a>
            <a
              onClick={() => scrollToSection("contact")}
              className="hover:text-orange-400 transition cursor-pointer"
              aria-label="Go to Contact Us Section"
            >
              Contact Us
            </a>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <a
              href="tel:+919940906161"
              className="flex items-center space-x-2 hover:text-orange-400 transition"
              aria-label="Call Elam Travels Trichy"
            >
              <Phone size={18} />
              <span>+91 99409 06161</span>
            </a>
            <a
              href="mailto:info@elamtravelstrichy.com"
              className="flex items-center space-x-2 hover:text-orange-400 transition"
              aria-label="Email Elam Travels Trichy"
            >
              <Mail size={18} />
              <span>info@elamtravelstrichy.com</span>
            </a>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div
          id="mobile-menu"
          className={`md:hidden ${isMenuOpen ? "block" : "hidden"}`}
          aria-hidden={!isMenuOpen}
        >
          <nav className="py-4 space-y-4">
            <a
              onClick={() => scrollToSection("home")}
              className="block hover:text-orange-400 transition py-2"
              aria-label="Go to Home Section"
            >
              Home
            </a>
            <a
              onClick={() => scrollToSection("about")}
              className="block hover:text-orange-400 transition py-2"
              aria-label="Go to About Us Section"
            >
              About Us
            </a>
            <a
              onClick={() => scrollToSection("vehicles")}
              className="block hover:text-orange-400 transition py-2"
              aria-label="Go to Vehicle Types Section"
            >
              Vehicle Types
            </a>
            <a
              onClick={() => scrollToSection("services")}
              className="block hover:text-orange-400 transition py-2"
              aria-label="Go to Services Section"
            >
              Services
            </a>
            <a
              onClick={() => scrollToSection("contact")}
              className="block hover:text-orange-400 transition py-2"
              aria-label="Go to Contact Us Section"
            >
              Contact
            </a>
            <div className="pt-4 border-t border-slate-800 space-y-4">
              <a
                href="tel:+919940906161"
                className="flex items-center space-x-2 hover:text-orange-400 transition py-2"
                aria-label="Call Elam Travels Trichy"
              >
                <Phone size={18} />
                <span>+91 99409 06161</span>
              </a>
              <a
                href="mailto:info@elamtravelstrichy.com"
                className="flex items-center space-x-2 hover:text-orange-400 transition py-2"
                aria-label="Email Elam Travels Trichy"
              >
                <Mail size={18} />
                <span>info@elamtravelstrichy.com</span>
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
